module.exports = __webpack_public_path__ + "img/LEGACY_DT.04654237.png";